import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherHeader } from "../../models/accvoucherheader.model";
import { VoucherInfo } from "../../models/voucherInfo.model";

@Component({
  selector: "ngx-create-closing-journal-voucher-form",
  templateUrl: "./create-closing-journal-voucher-form.component.html",
  styleUrls: ["./create-closing-journal-voucher-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateClosingJournalVoucherFormComponent extends BaseFormComponent<AccVoucherHeader> {
  erroremessage: String;
  ClosingJournalVoucherIsLoading: boolean = false;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.label = this.translate("ClientApp.BackOffice.ACC.AccCloseProfitandLossAccountsHeader.CreateClosingJournalVoucher");
    super.ngOnInit();
    this.apiName = "AccVoucherHeader";
    this.areaName = "Accounting";
    this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    this.setdefault();
    await this.setUnSelectAccounts();
  }
  setColumnAttribute() {
    this.orignalColumns = this.orignalColumns.filter((x) => x.name === "VoucherDate");
    this.columns = this.orignalColumns;
  }
  setdefault() {
    if (!this.model.VoucherDate) this.model.VoucherDate = new Date();
    if (
      new Date(this.model.VoucherDate).setHours(0, 0, 0, 0) > new Date(this.accountService.authService.currentFiscalYear.EndDate).setHours(0, 0, 0, 0)
    )
      this.model.VoucherDate = this.accountService.authService.currentFiscalYear.EndDate;
    this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    if (!this.model.FiscalYearId) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.model.FiscalYearId = x.Id;
          this.model.BranchId = this.accountService.authService.currentBranchId;
          this.getVoucher();
        }
      });
    } else this.getVoucher();
  }
  saveData() {
    if (this.model.FiscalYearId && this.model.FiscalYearId > 0)
      this.sts.showDialog(`آیا از صدور سند اطمینان دارید؟`, "اختتامیه", DialogType.confirm, () => this.CreateVoucher());
    else
      this.accountService.authService.currentFiscalYearobsr.subscribe((x) => {
        if (x) {
          this.model.FiscalYearId = x.Id;
          this.sts.showDialog(`آیا از صدور سند اطمینان دارید؟`, "اختتامیه", DialogType.confirm, () => this.CreateVoucher());
        }
      });
  }
  async save() {
    if (!this.isSaving) {
      this.isSaving = false;
      this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
      if (!this.model.FiscalYearId) {
        this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
          if (x) {
            this.model.FiscalYearId = x.Id;
            this.model.BranchId = this.accountService.authService.currentBranchId;
            this.saveData();
          }
        });
      } else this.saveData();
    }
  }
  getVoucher() {
    if (this.ClosingJournalVoucherIsLoading === true) return;
    let entity: VoucherInfo = <VoucherInfo>{};
    entity.BranchId = this.accountService.authService.currentBranchId;
    entity.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    this.ClosingJournalVoucherIsLoading = true;
    this.httpCommonService
      .create("AccCloseProfitandLossAccountsHeader/GetClosingJournalVoucher", entity)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.ClosingJournalVoucherIsLoading = false;
          if (data != undefined && (data as []).length > 0) {
            this.model = (data as AccVoucherHeader[])[0];
            this.setFormGroup(this.model);
          }
        },
        (error) => {
          this.ClosingJournalVoucherIsLoading = false;
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در بارگذاری اطلاعات");
        }
      );
  }
  CreateVoucher() {
    let entity: VoucherInfo = <VoucherInfo>{};
    entity.VoucherDate = this.formGroup.controls["VoucherDate"].value;
    entity.BranchId = this.accountService.authService.currentBranchId;
    entity.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    this.httpCommonService
      .create("AccCloseProfitandLossAccountsHeader/CreateClosingJournalVoucher", entity)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (row) => this.saveSuccessHelper(row),
        (error) => this.saveFailedHelper(error)
      );
  }
  deletVoucher() {
    this.sts.showDialog(`آیا از حذف سند اطمینان دارید؟`, "اختتامیه", DialogType.confirm, () => this.delete_Voucher());
  }
  delete_Voucher() {
    this.httpCommonService
      .delete("AccCloseProfitandLossAccountsHeader/DeleteClosingJournalVoucher", this.currentrow.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (row) => this.saveSuccessHelper(row),
        (error) => this.saveFailedHelper(error)
      );
  }

  async setUnSelectAccounts() {
    if (!this.accountService.authService.currentFiscalYear) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe(async (x) => {
        if (x) {
          if (this.formGroup) this.model.VoucherDate = this.formGroup.controls["VoucherDate"].value;
          const voucherInfo = new VoucherInfo();
          voucherInfo.VoucherDate = this.model.VoucherDate;
          voucherInfo.FiscalYearId = x.Id;
          voucherInfo.Id = this.model.Id;
          voucherInfo.BranchId = this.accountService.authService.currentBranchId;
          this.setValue("BranchId", voucherInfo.BranchId);
          this.setValue("FiscalYearId", voucherInfo.FiscalYearId);
          this.setValue("VoucherDate", voucherInfo.VoucherDate);
          if (!voucherInfo.VoucherDate) return;
          await this.httpCommonService
            .create(`AccCloseProfitandLossAccountsHeader/GetUnSelectAccounts`, voucherInfo)
            .pipe(takeUntil(this.ngUnsubscribe))
            .toPromise()
            .then(
              (data) => {
                if (data && data.length > 0) {
                  this.erroremessage = "حسابهاي موقت بسته نشده است. اول حسابهاي موقت را به بنديد.";
                }
                this.cd.markForCheck();
              },
              (error) => {
                this.saveFailedHelper(error);
              }
            );
        }
      });
    } else {
      if (this.formGroup) this.model.VoucherDate = this.formGroup.controls["VoucherDate"].value;

      const voucherInfo = new VoucherInfo();
      voucherInfo.VoucherDate = this.model.VoucherDate;
      voucherInfo.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
      voucherInfo.Id = this.model.Id;
      voucherInfo.BranchId = this.accountService.authService.currentBranchId;
      if (!voucherInfo.VoucherDate) return;
      this.setValue("BranchId", voucherInfo.BranchId);
      this.setValue("FiscalYearId", voucherInfo.FiscalYearId);
      this.setValue("VoucherDate", voucherInfo.VoucherDate);
      await this.httpCommonService
        .create(`AccCloseProfitandLossAccountsHeader/GetUnSelectAccounts`, voucherInfo)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (data) => {
            if (data && data.length > 0) {
              this.erroremessage = "حسابهاي موقت بسته نشده است. اول حسابهاي موقت را به بنديد.";
            }
            this.cd.markForCheck();
          },
          (error) => {
            this.erroremessage = `${Utilities.getHttpResponseMessage(error)}`;
            this.saveFailedHelper(error);
          }
        );
    }
  }
}
